<div class="ui-notification__card ui-notification__card--toast" [class]="'ui-notification__card--' + config().type">
  <span class="ui-notification__accent" aria-hidden="true"></span>

  <fa-icon class="ui-notification__icon" [icon]="icon()" />

  <div class="ui-notification__body">
    <p class="ui-notification__title">{{ config().title }}</p>
    @if (config().message) {
      <p class="ui-notification__message">{{ config().message }}</p>
    }
  </div>

  <button type="button" class="ui-notification__close" aria-label="Cerrar notificación" (click)="close()">
    <fa-icon [icon]="['fal', 'xmark']"></fa-icon>
  </button>
</div>
